import pluralize from 'pluralize'

export function usePluralize() {
    return {
        plural: (word: string, count = 1) => pluralize(word, count),
        singular: (word: string) => pluralize(word, 1),
    }
}
